import addMentionAddedRecipient from 'owa-editor-mentionsplugin/lib/actions/addMentionAddedRecipient';
import addMentionTuple from 'owa-editor-mentionsplugin/lib/actions/addMentionTuple';
import addSelectedRecipientToWell from 'owa-editor-mentionsplugin/lib/actions/addSelectedRecipientToWell';
import findReadWriteRecipient from 'owa-editor-mentionsplugin/lib//actions/findReadWriteRecipient';
import removeMentionAddedRecipient from 'owa-editor-mentionsplugin/lib/actions/removeMentionAddedRecipient';
import removeMentionTuple from 'owa-editor-mentionsplugin/lib/actions/removeMentionTuple';
import removePersonaFromWell from 'owa-editor-mentionsplugin/lib/actions/removePersonaFromWell';
import setIsSearching from 'owa-editor-mentionsplugin/lib/actions/setIsSearching';
import setIsSuggesting from 'owa-editor-mentionsplugin/lib/actions/setIsSuggesting';
import shiftAtMentionsHighlight from 'owa-editor-mentionsplugin/lib/actions/shiftAtMentionsHighlight';
import { showAtMentionsPopup, disposeAtMentionsPopup, } from 'owa-editor-mentionsplugin/lib/components/AtMentionsResult';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import compareFindRecipientPersonaType from 'owa-recipient-common/lib/utils/compareFindRecipientPersonaType';
var AT_MENTION_SEARCH_DELAY = 300;
var AT_MENTION_ELEMENT_ID_PREFIX = 'OWAAM';
var RESIZE_EVENT_NAME = 'resize';
var styles = require('owa-editor-mentionsplugin/lib/components/MentionsStyles.scss');
var MentionPluginDataProvider = /** @class */ (function () {
    function MentionPluginDataProvider(viewState, scrollAdapter, targetRecipientWell, onRecipientAdded, canModifyRecipients) {
        var _this = this;
        this.viewState = viewState;
        this.scrollAdapter = scrollAdapter;
        this.targetRecipientWell = targetRecipientWell;
        this.onRecipientAdded = onRecipientAdded;
        this.canModifyRecipients = canModifyRecipients;
        this.onIsSuggestingChanged = function (isSuggesting) {
            setIsSuggesting(_this.viewState, isSuggesting);
        };
        this.queryStringUpdated = function (queryString) {
            setIsSearching(_this.viewState, true, queryString);
            if (_this.timer) {
                clearTimeout(_this.timer);
                _this.timer = null;
            }
            _this.timer = setTimeout(function () {
                findReadWriteRecipient(_this.viewState, queryString, false);
                _this.timer = null;
            }, AT_MENTION_SEARCH_DELAY);
        };
        this.selectOption = function () {
            if (_this.viewState.selectedRecipientIndex == _this.viewState.recipientsShown.length) {
                findReadWriteRecipient(_this.viewState, _this.viewState.queryString, true);
            }
            else {
                _this.addRecipient();
            }
        };
        this.shiftHighlight = function (isDown) {
            shiftAtMentionsHighlight(_this.viewState, isDown);
        };
        this.onRemove = function (nodeRemoved, isBackspace) {
            if (isBackspace && nodeRemoved.textContent.split(' ').length > 1) {
                return _this.deleteLastSegment(nodeRemoved);
            }
            else {
                _this.deleteAtMention(nodeRemoved);
                return null;
            }
        };
        this.setCursorPoint = function (targetPoint, buffer) {
            showAtMentionsPopup(targetPoint, buffer, _this.viewState, _this.popupDiv, _this.addRecipient);
        };
        this.onScrollOrResize = function () {
            if (_this.viewState.isSuggesting) {
                _this.setIsSuggesting(false);
            }
        };
        this.addRecipient = function (recipient) {
            if (recipient === void 0) { recipient = null; }
            if (!recipient) {
                recipient = _this.viewState.recipientsShown[_this.viewState.selectedRecipientIndex];
            }
            _this.commitMention(_this.createInlineFromPersona(recipient));
            if (!_this.doesWellContainRecipient(recipient) && _this.canModifyRecipients) {
                addSelectedRecipientToWell(_this.viewState, _this.targetRecipientWell, recipient);
                if (recipient.EmailAddress) {
                    addMentionAddedRecipient(_this.viewState, recipient);
                }
            }
            setIsSuggesting(_this.viewState, false);
            if (_this.onRecipientAdded) {
                _this.onRecipientAdded();
            }
            logUsage(datapoints.MentionsAdded.datapoint.name);
        };
    }
    MentionPluginDataProvider.prototype.onInitalize = function (commitMentionCallback, isSuggestingCallback) {
        window.addEventListener(RESIZE_EVENT_NAME, this.onScrollOrResize);
        this.scrollAdapter.addScrollEventListener(this.onScrollOrResize);
        var divElement = document.createElement('div');
        divElement.id = 'atMentionsSearchPopup';
        document.body.appendChild(divElement);
        this.popupDiv = divElement;
        this.commitMention = commitMentionCallback;
        this.setIsSuggesting = isSuggestingCallback;
        this.canModifyRecipients = true;
    };
    MentionPluginDataProvider.prototype.onDispose = function () {
        window.removeEventListener(RESIZE_EVENT_NAME, this.onScrollOrResize);
        this.scrollAdapter.removeScrollEventListener(this.onScrollOrResize);
        clearTimeout(this.timer);
        this.timer = null;
        if (this.popupDiv) {
            disposeAtMentionsPopup(this.popupDiv);
            document.body.removeChild(this.popupDiv);
        }
        this.popupDiv = null;
    };
    MentionPluginDataProvider.prototype.doesWellContainRecipient = function (recipientToCheck) {
        if (!recipientToCheck) {
            recipientToCheck = this.viewState.recipientsShown[this.viewState.selectedRecipientIndex];
        }
        var elementsToCheck = this.targetRecipientWell.recipients.filter(function (value) {
            return compareFindRecipientPersonaType(value.persona, recipientToCheck);
        });
        return elementsToCheck.length > 0;
    };
    MentionPluginDataProvider.prototype.createInlineFromPersona = function (targetRecipient) {
        var anchorElement = document.createElement('a');
        var atMentionId = this.generateAtMentionId();
        anchorElement.id = atMentionId;
        anchorElement.innerText = '@' + targetRecipient.EmailAddress.Name;
        // We add both our styling for React, as well as the hard coded styling for MVVM.
        anchorElement.className = styles.mentions + ' mention ms-bgc-nlr ms-fcl-b';
        var email = targetRecipient.EmailAddress.EmailAddress;
        anchorElement.href = 'mailto:' + email;
        addMentionTuple(this.viewState, atMentionId, targetRecipient);
        return anchorElement;
    };
    MentionPluginDataProvider.prototype.generateAtMentionId = function () {
        return AT_MENTION_ELEMENT_ID_PREFIX + Math.round(Math.random() * 1000000).toString();
    };
    MentionPluginDataProvider.prototype.deleteLastSegment = function (node) {
        var splitContents = node.textContent.split(' ');
        splitContents.pop();
        node.textContent = splitContents.join(' ').trim();
        return node;
    };
    MentionPluginDataProvider.prototype.getIdValue = function (node) {
        return node.attributes && node.attributes.getNamedItem('id')
            ? node.attributes.getNamedItem('id').value
            : null;
    };
    MentionPluginDataProvider.prototype.deleteAtMention = function (node) {
        var nodeId = this.getIdValue(node);
        var _a = this.viewState, atMentionTuples = _a.atMentionTuples, mentionsAddedRecipients = _a.mentionsAddedRecipients;
        if (atMentionTuples[nodeId]) {
            if (atMentionTuples[nodeId].EmailAddress) {
                var indexToRemove = mentionsAddedRecipients.indexOf(atMentionTuples[nodeId].EmailAddress.EmailAddress);
                if (indexToRemove > -1) {
                    // If someone @mentioned someone multiple times, we should not remove until it's the last one.
                    var duplicated = Object.keys(atMentionTuples).some(function (key) {
                        if (key != nodeId && atMentionTuples[key]) {
                            return (atMentionTuples[key].EmailAddress &&
                                atMentionTuples[key].EmailAddress.EmailAddress ==
                                    atMentionTuples[nodeId].EmailAddress.EmailAddress);
                        }
                        else {
                            return false;
                        }
                    });
                    if (!duplicated && this.canModifyRecipients) {
                        removePersonaFromWell(this.targetRecipientWell, atMentionTuples[nodeId]);
                        removeMentionAddedRecipient(this.viewState, indexToRemove);
                    }
                }
            }
            removeMentionTuple(this.viewState, nodeId);
        }
    };
    MentionPluginDataProvider.prototype.getMentionsWrappersForSend = function (fromWrapper) {
        var atMentionTuples = this.viewState.atMentionTuples;
        var mentionsWrappers = [];
        Object.keys(atMentionTuples).forEach(function (key) {
            var persona = atMentionTuples[key];
            mentionsWrappers.push({
                Mentioned: persona.EmailAddress,
                CreatedBy: fromWrapper,
            });
        });
        if (mentionsWrappers.length > 0) {
            logUsage(datapoints.MentionsTotalSend.datapoint.name, datapoints.MentionsTotalSend.datapoint.customData(mentionsWrappers.length));
        }
        return mentionsWrappers;
    };
    MentionPluginDataProvider.prototype.getPendingTagsForSave = function () {
        var pendingTags = [];
        var _a = this.viewState, atMentionTuples = _a.atMentionTuples, mentionsAddedRecipients = _a.mentionsAddedRecipients;
        Object.keys(atMentionTuples).forEach(function (key) {
            var persona = atMentionTuples[key];
            pendingTags.push(JSON.stringify({
                b: key,
                a: JSON.stringify({
                    _type: 'MentionActionWrapper:#Exchange',
                    Mentioned: persona.EmailAddress,
                }),
            }));
        });
        if (mentionsAddedRecipients.length > 0) {
            pendingTags.push(JSON.stringify({
                b: 'MentionAddedRecipients',
                a: JSON.stringify(mentionsAddedRecipients),
            }));
        }
        if (pendingTags.length > 0) {
            logUsage(datapoints.MentionsTotalSave.datapoint.name, datapoints.MentionsTotalSave.datapoint.customData(Object.keys(atMentionTuples).length, mentionsAddedRecipients.length));
        }
        return pendingTags;
    };
    return MentionPluginDataProvider;
}());
export default MentionPluginDataProvider;
//# sourceMappingURL=MentionPluginDataProvider.js.map